import React from 'react';
import { Subscription } from 'react-apollo';

const SkippableSubscription = ({ skip, ...subscriptionProps }) => (
  skip ? <>{subscriptionProps.children({})}</> : <Subscription {...subscriptionProps} />
);

export default SkippableSubscription;
